import React, { useContext } from "react"
import TableStyleContext from "../TableStyleContext"
import {
  IconButton,
  DropdownMenu,
  DropdownMenuOptions
} from "../../../../mp-shared-components/generic-shared-components/components"
import { FaIcon } from "../../../../mp-core/icons"
import TableCell from "./TableCell"

type Props = {
  displayedProperties: string[]
  dropdownOptions: DropdownMenuOptions[]
  hasDiagonalHeaders?: boolean
  className?: string
}

export const TableHeaderActionsCell: React.FC<Props> = ({
  className,
  displayedProperties,
  dropdownOptions,
  hasDiagonalHeaders = false,
  ...rest
}) => {
  const { cx, classes } = useContext(TableStyleContext)

  return (
    <TableCell
      role="columnheader"
      className={cx(
        classes.tableCell,
        classes.headTableCell,
        classes.actionCell,
        className,
        { [classes.actionCellDiagonal]: hasDiagonalHeaders }
      )}
      data-automation-id="data-table-head-menu-cell"
      {...rest}
    >
      {displayedProperties && (
        // If "displayedProperties" are present, display dropdown with options.
        <DropdownMenu
          withCheckbox
          id="displayedProperties"
          dropdownTitle="View Columns"
          className={classes.configDropdown}
          aria-label="Settings"
          anchor={
            <IconButton
              size="xsmall"
              data-automation-id="data-table-head-menu-button"
            >
              <FaIcon solid name="cog" />
            </IconButton>
          }
          options={dropdownOptions}
        />
      )}
    </TableCell>
  )
}
